export function toggleModal(name, e){
  console.warn('toggleModal is DEPRECATED - use toggleStateBool instead')

  if (e){
    e.preventDefault()
  }

  const modal = {}
  modal[name] = !this.state[name]
  this.setState(modal)
}

export function toggleStateBool(object, name, e){
  if (e) e.preventDefault()

  const change = {}
  change[name] = !object.state[name]
  object.setState(change)
}

export function handleChange(name, e){
  console.warn('handleChange is DEPRECATED - use changeNameValue instead')

  const change = {}
  change[name] = e.target.value
  this.setState(change)
}

export function handleStateChange(object, name, e){
  console.warn('handleStateChange is DEPRECATED - use changeNameValue instead')

  const change = {}
  change[name] = e.target.value
  object.setState(change)
}

export function handleStateChangeBool(object, name, e){
  console.warn('handleStateChangeBool is DEPRECATED - use changeNameValue instead')

  const change = {}
  change[name] = e.target.value === 'true'
  object.setState(change)
}

export function handleStateChangeFloat(object, name, e){
  console.warn('handleStateChangeFloat is DEPRECATED - use changeNameValue instead')

  const change = {}
  change[name] = parseFloat(e.target.value)
  object.setState(change)
}

export function changeNameValue(object, name, value){
  const change = {}
  change[name] = value
  object.setState(change)
}

export function changeMultipleNameValues(object, changes = {}){
  object.setState(changes)
}

export function handleChangeBool(name, e){
  console.warn('handleChangeBool is DEPRECATED - use changeNameValue instead')

  const change = {}
  change[name] = e.target.value === 'true'
  this.setState(change)
}

export function handleChangeInteger(name, e){
  console.warn('handleChangeInteger is DEPRECATED - use changeNameValue instead')

  const change = {}
  change[name] = e.target.value.replace(/\D/g, '')
  this.setState(change)
}

export function handleChangeDateTime(name, value){
  console.warn('handleChangeDateTime is DEPRECATED - use changeNameValue instead')

  const change = {}
  change[name] = value
  this.setState(change)
}

export function handleFile(object, name, e){
  const reader = new FileReader()
  const file = e.target.files[0]

  reader.onload = (upload) => {
    const state = {}
    state[name] = upload.target.result
    object.setState(state)
  }

  reader.readAsDataURL(file)
}
